import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTagsQuery = createQueryHook(MembershipsCreatorApiClient.getPostTags, {
  queryKey: ['tags'],
})
